// extracted by mini-css-extract-plugin
module.exports = {"active":"ProductStatus_active__1rl1K","staging":"ProductStatus_staging__-srUe","readyForReview":"ProductStatus_readyForReview__3s6sh","archived":"ProductStatus_archived__35viZ"};